import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrNotificationCategory.ts
var t = () => e("notificationCategory");
//#endregion
export { t as useTrNotificationCategory };
